import React, { memo } from 'react'
import { Divider, Grid, Stack, Link as MuiLink } from '@mui/material'
import { faCoins, faGifts } from '@fortawesome/pro-light-svg-icons'
import { faEthereum } from '@fortawesome/free-brands-svg-icons'
import { Trans } from 'react-i18next'

import BaseCard from '../shared/baseCard/BaseCard'
import Text from '../shared/text/Text'
import DefaultText from '../shared/text/DefaultText'
import SaleDetails from './SaleDetails'
import QBXBanner from './QBXBanner'
import DepositStatus from './DepositStatus'
import {
  ANNOUNCE_WINNERS_TIME,
  CURRENCIES,
  ENABLE_SALE_RESULTS
} from '../../constants/app'
import CustomButton from '../shared/buttons/CustomButton'
import MultiplierTimer from './MultiplierTimer'
import CustomAlert from '../shared/CustomAlert/CustomAlert'
import FaIcon from '../shared/faIcon/FaIcon'

const SaleRunning = ({
  t,
  onClickDeposit,
  mainProfile,
  isWalletConnected,
  saleEnded,
  onClickResults,
  onClickRewardMultipliers,
  address,
  contractAddress
}) => {
  return (
    <BaseCard>
      <Grid container>
        <Grid item xs={12}>
          <Text variant='h2' label={t('home.welcome-text')} fontWeight={700} />
          <DefaultText label={t('home.welcome-desc')} />
        </Grid>
      </Grid>
      <Grid container spacing={6}>
        <Grid item xs={12} sm={8}>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <CustomAlert
                info={t('home.sale-note')}
                icon={<FaIcon icon={faGifts} />}
              />
              <SaleDetails
                t={t}
                mainProfile={mainProfile}
                saleEnded={saleEnded}
                address={isWalletConnected && address}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={4}>
          <QBXBanner t={t}>
            {saleEnded ? (
              <Stack spacing={2} alignItems='center'>
                <DefaultText
                  label={
                    <Trans
                      i18nKey={`results.${ENABLE_SALE_RESULTS ? 'the-wait-is-over' : 'thank-you-for-participating'}`}
                      values={{
                        time: ANNOUNCE_WINNERS_TIME
                      }}
                    />
                  }
                  textAlign='center'
                />
                <CustomButton
                  onClick={onClickResults}
                  icon={faCoins}
                  disabled={!isWalletConnected || !ENABLE_SALE_RESULTS}
                  label={t('results.view-results')}
                />
              </Stack>
            ) : (
              <Stack spacing={2} alignItems='center'>
                <CustomButton
                  onClick={onClickDeposit}
                  icon={faEthereum}
                  disabled={!isWalletConnected || saleEnded || !contractAddress}
                  label={`${t('home.deposit')} ${CURRENCIES.DEFAULT}`}
                />
                <Text
                  label={
                    <MuiLink onClick={onClickRewardMultipliers} color='inherit'>
                      {t('home.points-bonuses')}
                    </MuiLink>
                  }
                  textAlign='center'
                />
                <MultiplierTimer saleEnded={saleEnded} />
              </Stack>
            )}
          </QBXBanner>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ mb: { md: 6, xs: 3 } }} />
          <DepositStatus t={t} mainProfile={mainProfile} />
        </Grid>
      </Grid>
    </BaseCard>
  )
}

export default memo(SaleRunning)
